(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* La feuille visuelle du méga-menu n'est pas critique tant que le menu reste
     fermé (ce socle vient de main.css + header-enhancements.css). Le lien
     media=print télécharge sans bloquer; une intention utilisateur ou le temps
     idle l'active plus tôt si le transfert n'est pas encore terminé. */
  (function() {
    var stylesheet = document.getElementById('mega-menu-enhancements-css');
    if (!stylesheet || stylesheet.media === 'all') return;

    function activateMegaMenuStyles() {
      stylesheet.media = 'all';
    }

    var menu = document.querySelector('main-menu');
    if (menu) {
      menu.addEventListener('pointerover', activateMegaMenuStyles, { once: true, passive: true });
      menu.addEventListener('focusin', activateMegaMenuStyles, { once: true });
      menu.addEventListener('touchstart', activateMegaMenuStyles, { once: true, passive: true });
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(activateMegaMenuStyles, { timeout: 2000 });
    } else {
      window.setTimeout(activateMegaMenuStyles, 1500);
    }
  })();

  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  /* Feuille montante mobile : la croix et le voile referment tout le tiroir.
     On repasse par le <summary> pour que MainMenu rende le focus et libère le scroll. */
  (function() {
    document.addEventListener('click', function(evt) {
      var trigger = evt.target.closest('[data-msheet-close]');
      if (!trigger) return;

      var menu = trigger.closest('main-menu');
      if (!menu) return;

      evt.preventDefault();

      var toggle = menu.querySelector('.main-menu__toggle');
      var disclosure = menu.querySelector('.main-menu__disclosure');
      if (toggle && disclosure && disclosure.classList.contains('is-open')) toggle.click();
    });
  })();

  /* Tuiles du méga-menu bureau : réveiller les images avant l'ouverture.
     Elles portent loading="lazy" et vivent dans un conteneur masqué, donc elles
     ne se téléchargeaient qu'une fois le menu affiché — la tuile restait noire
     le temps du transfert. On les bascule en eager dès l'intention de survol,
     et pour le seul rayon visé : 5 images, ~180 Ko, au lieu de 1,1 Mo si on
     chargeait les six rayons à chaque page. Elles restent en priorité réseau
     automatique : seule l'image LCP de la page peut recevoir `high`. */
  (function() {
    var nav = document.querySelector('.main-nav');
    if (!nav) return;
    var desktopMedia = window.matchMedia('(min-width: 769px)');

    function reveiller(item) {
      if (!item || item.dataset.tuilesPretes) return;

      /* Le panneau historique .msd reste necessaire au menu mobile, mais il est
         invisible sur bureau lorsqu'un panneau cartes est actif. N'arme pas le
         marqueur ici : apres un passage en mobile, les images pourront encore
         etre reveillees par une interaction reelle. */
      var panneauCartes = item.querySelector('.main-nav__child.mega-nav--cartes');
      if (panneauCartes && desktopMedia.matches) return;

      item.dataset.tuilesPretes = '1';
      item.querySelectorAll('.msd__sidebar-thumb img[loading="lazy"]').forEach(function(img) {
        img.loading = 'eager';
      });
    }

    /* pointerover et focusin remontent tous les deux, contrairement à
       pointerenter : une seule écoute sur la barre suffit pour les sept rayons,
       au clavier comme à la souris. */
    ['pointerover', 'focusin'].forEach(function(evenement) {
      nav.addEventListener(evenement, function(evt) {
        var cible = evt.target.closest ? evt.target.closest('.main-nav > li') : null;
        if (cible) reveiller(cible);
      });
    });
  })();


  } catch(e) { console.error(e); }
})();
})();
